import { FaMapMarkerAlt, FaEnvelope, FaPhoneAlt } from "react-icons/fa";
import "./ContactSection.css";
import ContactImage from "../../assets/wind.png";

export default function ContactSection() {
  return (
    <section className="csec-wrapper">
      {/* Left Image */}
      <div className="csec-image">
        <img
          src={ContactImage}
          alt="Contact CM Green Energy"
          className="csec-img"
          loading="lazy"
        />
      </div>

      {/* Right Content */}
      <div className="csec-content">
        <p className="csec-subtitle">Contact Us</p>

        <h2 className="csec-title">Let’s Connect</h2>

        <p className="csec-text">
          At <strong>CM Green Energy India Pvt. Ltd.</strong>, we are dedicated to
          driving sustainable growth through clean and reliable energy solutions.
          Connect with us for project inquiries, collaborations, or to learn more
          about our renewable energy services and innovations.
        </p>

        <div className="csec-info">
          {/* Address */}
          <div className="csec-item">
            <div className="csec-icon">
              <FaMapMarkerAlt aria-hidden="true" />
            </div>
            <div>
              <h4 className="csec-heading">Office Address</h4>
              <p className="csec-description">
                Moongiltholuvu,<br />
                Udumalpet – 642202
              </p>
            </div>
          </div>

          {/* Email */}
          <div className="csec-item">
            <div className="csec-icon">
              <FaEnvelope aria-hidden="true" />
            </div>
            <div>
              <h4 className="csec-heading">Mail Us</h4>
              <p className="csec-description">
                <a
                  href="mailto:cmpranesh@cmgroupofcompanies.com"
                  style={{ color: "inherit", textDecoration: "none" }}
                >
                  cmpranesh@cmgroupofcompanies.com
                </a>
              </p>
            </div>
          </div>

          {/* Phone */}
          <div className="csec-item">
            <div className="csec-icon">
              <FaPhoneAlt aria-hidden="true" />
            </div>
            <div>
              <h4 className="csec-heading">Call Us</h4>
              <p className="csec-description">
                <a
                  href="tel:+919944662747"
                  style={{ color: "inherit", textDecoration: "none" }}
                >
                  +91 99446 62747
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
